// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Control_Monad_Writer = require("../Control.Monad.Writer/index.js");
var Control_Monad_Writer_Class = require("../Control.Monad.Writer.Class/index.js");
var Control_Monad_Writer_Trans = require("../Control.Monad.Writer.Trans/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Lens = require("../Lunarbox.Data.Lens/index.js");
var SolveState = function (x) {
    return x;
};
var SolveContext = function (x) {
    return x;
};
var Solve = function (x) {
    return x;
};
var semigroupSolveState = Data_Semigroup.semigroupRecord()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
    return "errors";
}))()(Data_Semigroup.semigroupRecordNil)(Data_Semigroup.semigroupArray));
var runSolve = function (ctx) {
    return function (v) {
        return Control_Monad_Writer.runWriter(Control_Monad_Reader_Trans.runReaderT(v)(ctx));
    };
};
var newtypeSolveState = new Data_Newtype.Newtype(function (n) {
    return n;
}, SolveState);
var newtypeSolveContent = new Data_Newtype.Newtype(function (n) {
    return n;
}, SolveContext);
var newtypeSolve = new Data_Newtype.Newtype(function (n) {
    return n;
}, Solve);
var monoiSolveState = Data_Monoid.monoidRecord()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
    return "errors";
}))(Data_Monoid.monoidArray)()(Data_Monoid.monoidRecordNil));
var monadWriterSolve = Control_Monad_Reader_Trans.monadWriterReaderT(Control_Monad_Writer_Trans.monadWriterWriterT(monoiSolveState)(Data_Identity.monadIdentity));
var monadTellSolve = Control_Monad_Reader_Trans.monadTellReaderT(Control_Monad_Writer_Trans.monadTellWriterT(monoiSolveState)(Data_Identity.monadIdentity));
var monadSolve = Control_Monad_Reader_Trans.monadReaderT(Control_Monad_Writer_Trans.monadWriterT(monoiSolveState)(Data_Identity.monadIdentity));
var monadReaderSolve = Control_Monad_Reader_Trans.monadReaderReaderT(Control_Monad_Writer_Trans.monadWriterT(monoiSolveState)(Data_Identity.monadIdentity));
var monadAskSolve = Control_Monad_Reader_Trans.monadAskReaderT(Control_Monad_Writer_Trans.monadWriterT(monoiSolveState)(Data_Identity.monadIdentity));
var functorSolve = Control_Monad_Reader_Trans.functorReaderT(Control_Monad_Writer_Trans.functorWriterT(Data_Identity.functorIdentity));
var bindSolve = Control_Monad_Reader_Trans.bindReaderT(Control_Monad_Writer_Trans.bindWriterT(semigroupSolveState)(Data_Identity.bindIdentity));
var applySolve = Control_Monad_Reader_Trans.applyReaderT(Control_Monad_Writer_Trans.applyWriterT(semigroupSolveState)(Data_Identity.applyIdentity));
var applicativeSolve = Control_Monad_Reader_Trans.applicativeReaderT(Control_Monad_Writer_Trans.applicativeWriterT(monoiSolveState)(Data_Identity.applicativeIdentity));
var _location = function (dictStrong) {
    var $15 = Lunarbox_Data_Lens.newtypeIso(newtypeSolveContent)(dictStrong);
    var $16 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "location";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($17) {
        return $15($16($17));
    };
};
var throwTypeError = function (dictMonoid) {
    return function (getError) {
        var m = Control_Bind.bind(bindSolve)(Control_Monad_Reader_Class.asks(monadAskSolve)(Data_Lens_Getter.view(_location(Data_Lens_Internal_Forget.strongForget))))((function () {
            var $18 = Control_Monad_Writer_Class.tell(monadTellSolve);
            var $19 = Control_Applicative.pure(Control_Applicative.applicativeArray);
            return function ($20) {
                return $18(SolveState((function (v) {
                    return {
                        errors: v
                    };
                })($19(getError($20)))));
            };
        })());
        return Data_Functor.voidRight(functorSolve)(Data_Monoid.mempty(dictMonoid))(m);
    };
};
module.exports = {
    Solve: Solve,
    SolveContext: SolveContext,
    SolveState: SolveState,
    "_location": _location,
    runSolve: runSolve,
    throwTypeError: throwTypeError,
    newtypeSolveContent: newtypeSolveContent,
    newtypeSolveState: newtypeSolveState,
    semigroupSolveState: semigroupSolveState,
    monoiSolveState: monoiSolveState,
    newtypeSolve: newtypeSolve,
    functorSolve: functorSolve,
    applySolve: applySolve,
    applicativeSolve: applicativeSolve,
    bindSolve: bindSolve,
    monadSolve: monadSolve,
    monadTellSolve: monadTellSolve,
    monadWriterSolve: monadWriterSolve,
    monadAskSolve: monadAskSolve,
    monadReaderSolve: monadReaderSolve
};
